// Verbose logs are enabled only for known local/dev/staging API hosts.
// Allow exact dev/staging hosts instead of the entire hosting domain.
const LOCAL_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0', '[::1]'];
const NON_PROD_HOSTS = [
  'dev.natureland.hipster-virtual.com', // Development
  'natureland.hipster-virtual.com', // Staging
];

function resolveHostname() {
  const rawBaseUrl = process.env.REACT_APP_BASE_URL;
  if (!rawBaseUrl) return null;
  try {
    return new URL(rawBaseUrl).hostname.toLowerCase();
  } catch {
    return null;
  }
}

function resolveLoggingEnabled(hostname) {
  return LOCAL_HOSTS.includes(hostname) || NON_PROD_HOSTS.includes(hostname);
}

const currentHostname = resolveHostname();
export const isLoggingEnabled = resolveLoggingEnabled(currentHostname);
const noop = () => {};

const logger = {
  log: isLoggingEnabled ? (...args) => console.log('[APP]', ...args) : noop,
  info: isLoggingEnabled ? (...args) => console.info('[INFO]', ...args) : noop,
  debug: isLoggingEnabled ? (...args) => console.debug('[DEBUG]', ...args) : noop,
  warn: isLoggingEnabled ? (...args) => console.warn('[WARN]', ...args) : noop,
  error: (...args) => {
    console.error('[ERROR]', ...args);

    // Preserve the existing error reporting integration in every environment.
    if (process.env.REACT_APP_SENTRY_DSN && typeof window !== 'undefined' && window.Sentry) {
      const exception = args.find((value) => value instanceof Error) ?? args[1] ?? args[0];
      const message = typeof args[0] === 'string' ? args[0] : args[0]?.message || 'Application error';
      window.Sentry.captureException(exception, { tags: { message } });
    }
  },
  logEnvironment: () => logger.info(`Debug logs: ${isLoggingEnabled}`),
};

export default logger;
